module.exports = __webpack_public_path__ + "img/banner_operator.fef061fd.png";